import React from 'react';
import { ServiceSpec } from '../../data/servicesData';

interface SpecificationsGridProps {
  specifications: ServiceSpec[];
}

const SpecificationsGrid: React.FC<SpecificationsGridProps> = ({
  specifications
}) => {
  return (
    <div className="specifications-content">
      <div className="specifications-grid">
        {specifications.map((spec, index) => (
          <div key={index} className="specification-item">
            <span className="spec-label">{spec.label}</span>
            <span className="spec-value">{spec.value}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SpecificationsGrid;
